<h3>Review Notes</h3>
@if (reviewNotes?.length > 0) {
  <section>
    @for (note of reviewNotes; track note) {
      <div class="padding-all margin-top margin-bottom">
        @if (note.text !== null) {
          <div #replyForm>
            @if (canViewNote(note)) {
              <div class="note-group padding-all" [ngClass]="{ 'private-note' : note.type < 2, 'public-note': note.type == 2 }">
                @if (note.notes && note.notes.length > 0) {
                  <div class="float-left">
                    @if (!replyForm.opened) {
                      <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-right" class="small gray"></svg-icon></button>
                    }
                    @if (replyForm.opened) {
                      <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-down" class="small gray"></svg-icon></button>
                    }
                  </div>
                }
                <div class="notes">
                  <div class="note-header default-font"><strong>{{note.createdBy}}</strong><span class="float-right">{{note.createdDate | date: 'M/d/yy | h:mma'}}</span></div>
                  <div [innerHTML]="note.text"></div>
                  <hr />
                  <div class="childNotes" [ngClass]="{ 'opened': replyForm.opened }">
                    @for (childNote of note.notes; track childNote) {
                      <div>
                        <div class="note-header default-font">
                          <strong>{{childNote.createdBy}}</strong><span class="float-right">{{childNote.createdDate | date: 'M/d/yy | h:mma'}}</span>
                        </div>
                        <div [innerHTML]="childNote.text"></div>
                      </div>
                    }
                  </div>
                </div>
                @if (!replyForm.isReplying) {
                  <div class="text-align-right">
                    <button (click)="openReplyForm(replyForm)">
                      <svg-icon class="cursor-pointer" icon="icon-reply"></svg-icon>
                    </button>
                  </div>
                }
              </div>
            }
            @if (replyForm.isReplying) {
              <div class="margin=top" [(froalaModel)]="replyForm.replyText" [froalaEditor]="replyFroalaOptions"></div>
              @if (replyForm.isDirty && !replyForm.replyText) {
                <div class="notes error">
                  <small class="error">Reply text is required</small>
                </div>
              }
              <div class="text-align-center minor-margin-top">
                <span class="minor-margin-right">
                  <button class="button hollow white-background" (click)="resetReplyForm(replyForm)">Cancel</button>
                </span>
                <span class="minor-margin-left">
                  <button class="button" (click)="reply(note, replyForm)">Add Note</button>
                </span>
              </div>
            }
          </div>
        }
      </div>
    }
  </section>
} @else {
  <p>There are currently no review notes.</p>
}


